import { ICliente } from './cliente.model';
import { ISimulacion } from './simulacion.model';
import { ICuota } from './cuota.model';

export interface ISimulacionDTO {
  cliente?: ICliente | null;
  simulacion?: ISimulacion | null;
  cuotas?: ICuota[] | [];
}

export class SimulacionDTO implements ISimulacionDTO {
  constructor(
      public cliente?: ICliente | null,
      public simulacion?: ISimulacion | null,
      public cuotas?: ICuota[] | []
  ) {
  }
}
